import { render, staticRenderFns } from "./HeaderLabel.vue?vue&type=template&id=30b37c6b&scoped=true"
import script from "./HeaderLabel.vue?vue&type=script&lang=js"
export * from "./HeaderLabel.vue?vue&type=script&lang=js"
import style0 from "./HeaderLabel.vue?vue&type=style&index=0&id=30b37c6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b37c6b",
  null
  
)

export default component.exports